import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import axios from '../utils/interceptor';

// console.log('storage', storage);
const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_CHECKOUT_API_BASE_URL || '/api',
  credentials: 'include',
  prepareHeaders: (headers) => {
    const token = window?.EMBD_ENV?.CHECKOUT_TOKEN;
    if (token) headers.set('authorization', `Bearer ${token}`);
    return headers;
  }
});

export default baseQuery;

export const axiosBaseQuery = ({
  prepareHeaders
} = {}) => async (args, api) => {
  const { url, method = 'GET', data, params, headers: initHeaders } = args || {};
  if (!url) return { error: { status: 'NO_URL', data: 'No URL provided to axiosBaseQuery' } };

  let finalHeaders = { ...(initHeaders || {}), 'Content-Type': 'application/json' };
  if (prepareHeaders) {
    const h = new Headers();
    Object.entries(finalHeaders).forEach(([k, v]) => h.set(k, v));
    prepareHeaders(h, { getState: api.getState, extra: api.extra, endpoint: api.endpoint });
    finalHeaders = Object.fromEntries(h.entries());
  } else {
    const token = window?.EMBD_ENV?.CHECKOUT_TOKEN;
    if (token) finalHeaders.authorization = `Bearer ${token}`;
  }

  const path = url.startsWith('/') ? url : `/${url}`;
  const fullUrl = /^https?:\/\//i.test(path) ? path : `${path}`;

  try {
    const response = await axios({
      url: fullUrl,
      method,
      // For GET use params, for others use data
      params: method === 'GET' ? (params || data) : params,
      data: method === 'GET' ? undefined : data,
      headers: finalHeaders,
      withCredentials: true,
      signal: api.signal
    });
    return { data: response.data };
  } catch (error) {
    return {
      error: {
        status: error.response?.status || 'NETWORK_ERROR',
        data: error.response?.data || error.message
      }
    };
  }
};
